import React from 'react';

import { observer } from 'mobx-react';

import classes from './NgzHeader.module.scss';
import { angularizeWithProviders } from '../../providers';
import { LogoLink } from './LogoLink/LogoLink';
import { PagesNavBox } from './PagesNavBox/PagesNavBox';
import { UserMenu } from './UserMenu/UserMenu';
import { loggedInUserDataStore } from '../../stores/loggedInUserDataStore';
import { usePageConfig } from '../../hooks/usePageConfig';
import { solutionsStore } from '../../stores/solutionsStore';
import { HeaderBar } from '../../components/header-components/HeaderBar/HeaderBar';
import { HeaderSolutionSwitcher } from './HeaderSolutionSwitcher/HeaderSolutionSwitcher';

type NgzHeaderProps = {
  /**
   * Used only for standalone HTML pages (e.g. create-user-account.html)
   * For routes, use pageConfig.hideNavBar instead
   */
  isHideNavBar?: boolean;
};

// TODO LMP-2471 delete isHideNavBar props
const NgzHeader = observer(({ isHideNavBar = false }: NgzHeaderProps) => {
  const { loggedInUser } = loggedInUserDataStore;
  const { activeSolution, availableSolutions } = solutionsStore;
  const { hideNavBar, hideHeader } = usePageConfig();

  if (hideHeader) {
    return null;
  }

  const isMultipleSolutions = availableSolutions.length > 1;
  const shouldHideNavBar = hideNavBar || isHideNavBar;

  return (
    <HeaderBar solution={activeSolution}>
      <div className={classes.logoBox}>
        {isMultipleSolutions ? (
          <HeaderSolutionSwitcher />
        ) : (
          <LogoLink solution={activeSolution} />
        )}
      </div>
      {!shouldHideNavBar && (
        <>
          {loggedInUser?.id && activeSolution && (
            <PagesNavBox activeSolution={activeSolution} />
          )}
          {loggedInUser && <UserMenu />}
        </>
      )}
    </HeaderBar>
  );
});

angularizeWithProviders(NgzHeader, 'ngzReactHeader', { isHideNavBar: '<' });

export { NgzHeader };
